import { Component, OnInit, Input } from '@angular/core';
import { ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import * as firebase from 'firebase'
import * as moment from 'moment'
import { GranServicioDePTWService } from '../gran-servicio-de-ptw.service';

import { ModalController } from '@ionic/angular';



@Component({
  selector: 'app-modal-actividades-trabajador',
  templateUrl: './modal-actividades-trabajador.page.html',
  styleUrls: ['./modal-actividades-trabajador.page.scss'],
})
export class ModalActividadesTrabajadorPage implements OnInit {

  @Input()trabajador;
  @Input()indicetrabajador;
  @Input()actividadSeleccionada;
  @Input()arrayDeEmpleados;
  @Input()dataActividad;
  @Input()crearOeditar;
  @Input()indiceActividad;

  //----
  @Input()actividadParaEditar
  @Input()indiceActividadParaEditar


  arrayDocumentosTrabajador=[]

  arraydeactividades=[]

  trabajoenalturas={descripcionTarea:'',vencimientoCertAlturas:'', urlCertificado:'', alturamaxima:'',vencimientoCertMedico:'',urlCertificadoMedico:'',solicitante:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[], }
  trabajoencaliente={descripcionTarea:'',medidasPrevencion:'', areadetrabajo:[],resultadosMonitoreo:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  levantamientomecanico={descripcionTarea:'',vencimientoCertMeca:'', urlCertificadoIzaje:'',plandeizaje70:'', lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[] }
  energiaspeligrosas={descripcionTarea:'',intervencionElectrica:'', certCONTE:'', urlCertCONTE:'',tipoDeEnergias:[],equiposAterrizar:'',equiposABloquear:'',resultadosMonitoreo:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  espaciosconfinados={descripcionTarea:'',urlCertificadoConfinados:'',urlCertificadoAptitudConfinados:'',equipos:'',monitoreoO2:'',urlCertificadoEquiposConfinados:'',entrenamientos:[],lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}
  hazmat={descripcionTarea:'',sustanciasQuimicas:'',elementosDemarcacion:'',fichasdeseguridad:'',sustanciasRotuladas:'',matrizCompatibilidad:'',elementosTrasvase:'',elementosEmergencia:[], epp:[], sustAMonitorear:'',monitoreoO2:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[] }
  supervisionymonitoreo={descripcionTarea:'',tareasSupervision:'',capBolsillo:'',reglasOro:''}
  otros={descripcionTarea:'',actividad1:'',actividad2:'',actividad3:'',actividad4:'',lineaAaislar:'',barrerasFisicas:'',actividadesTraslapantes:'',controlesManos:'',sintomas:[],situaciones:[]}

  subiendo = false
  changedData=true
  percentage=0;



  herramientasYControlesTrabajoEnAlturas = {
    herramientas: { arneses: 0, andamios: 0, eslingas: 0, eslingaDePosicionamiento: 0, cascos: 0, tieOff: 0, poleas: 0, descendedor: 0, gibbs: 0, lineaDeVida: 0, arrestador: 0, mosquetones: 0, cuerdas: 0, escaleras: 0, cintaDeAnclaje: 0, pertiga: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesTrabajoEnCaliente = {
    herramientas: { pulidoras: 0, motosoldadores: 0, esmeriles: 0, plantasElectricas: 0, taladrosPercutores: 0, sierras: 0, motosierras: 0, guadanas: 0, otrosChispas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesLevantamientoMecanico = {
    herramientas: { grua: 0, camionBrazoGrua: 0, montacargas: 0, telehandlers: 0, aparejos: 0, gibbs: 0, arrestadores: 0, mosquetones: 0, cuerdas: 0, otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEnergiasPeligrosas = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesEspaciosConfinados = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesHazmat = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  }

  herramientasYControlesSupervicionYmonitoreo = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 

  herramientasYControlesOtros = {
    herramientas: { otros: 0 },
    actividadIncluye: [],
    peligros: [],
    controles: []
  } 


  constructor(public servicioLoadersAlertasService:ServicioLoadersAlertasService, public granServicioDePTWService:GranServicioDePTWService, public modalCtrl: ModalController) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.recuperaDocumentosTrabajador()
    
  }


  recuperaDocumentosTrabajador(){
    this.servicioLoadersAlertasService.presentLoading("Cargando documentos... / Loading documents...")
    let docref = firebase.firestore().collection("trabajadores").doc(this.trabajador.id)
    docref.get().then((doc)=>{

      this.trabajoenalturas.urlCertificado=doc.data().urlCertificadoAlturas;
      this.trabajoenalturas.urlCertificadoMedico=doc.data().urlCertificadoAptitud;
      this.espaciosconfinados.urlCertificadoAptitudConfinados=doc.data().urlCertificadoAptitudConfinados;
      this.espaciosconfinados.urlCertificadoConfinados=doc.data().urlCertificadoConfinados;
      this.espaciosconfinados.urlCertificadoEquiposConfinados=doc.data().urlCertificadoEquiposConfinados;
      this.levantamientomecanico.urlCertificadoIzaje=doc.data().urlCertificadoIzaje;
      this.energiaspeligrosas.urlCertCONTE=doc.data().urlCertificadoCONTE;
      
    }).then(()=>{
        this.servicioLoadersAlertasService.loadingController.dismiss()
        if(this.crearOeditar=='editar'){
          this.actividadSeleccionada=this.actividadParaEditar.actividad
          this.asignavaloresACampos()
        }
        
    }).catch((err)=>{
      this.servicioLoadersAlertasService.loadingController.dismiss()
      this.servicioLoadersAlertasService.alerta("error",err)
    })
  }









 

  asignavaloresACampos(){

      if(this.actividadParaEditar.actividad =='TRABAJO EN ALTURAS'){
        // this.trabajoenalturas=this.dataActividad
        this.trabajoenalturas= this.actividadParaEditar.dataActividad
        this.herramientasYControlesTrabajoEnAlturas=this.actividadParaEditar.herramientasYcontroles
        this.trabajoenalturas.vencimientoCertAlturas = moment(this.trabajoenalturas.vencimientoCertAlturas).format('YYYY-MM-DD')
        this.trabajoenalturas.vencimientoCertMedico = moment(this.trabajoenalturas.vencimientoCertMedico).format('YYYY-MM-DD')
        
      }else
      if(this.actividadParaEditar.actividad == 'TRABAJO EN CALIENTE'){
      //  this.trabajoencaliente=this.dataActividad
        this.trabajoencaliente= this.actividadParaEditar.dataActividad
        this.herramientasYControlesTrabajoEnCaliente = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'LEVANTAMIENTO MECÁNICO'){
        // this.levantamientomecanico=this.dataActividad
        this.levantamientomecanico=this.actividadParaEditar.dataActividad
        this.herramientasYControlesLevantamientoMecanico = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'ENERGÍAS PELIGROSAS'){
        // this.energiaspeligrosas=this.dataActividad
        this.energiaspeligrosas=this.actividadParaEditar.dataActividad
        this.herramientasYControlesEnergiasPeligrosas = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'ESPACIOS CONFINADOS'){
        // this.espaciosconfinados=this.dataActividad
        this.espaciosconfinados=this.actividadParaEditar.dataActividad
        this.herramientasYControlesEspaciosConfinados = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'HAZMAT'){
        // this.hazmat=this.dataActividad
        this.hazmat=this.actividadParaEditar.dataActividad
        this.herramientasYControlesHazmat = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'TRABAJO EN CALIENTE'){
        // this.trabajoencaliente=this.dataActividad
        this.trabajoencaliente=this.actividadParaEditar.dataActividad
        this.herramientasYControlesTrabajoEnCaliente = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'SUPERVISIÓN Y MONITOREO'){
        // this.supervisionymonitoreo=this.dataActividad
        this.supervisionymonitoreo=this.actividadParaEditar.dataActividad
        this.herramientasYControlesSupervicionYmonitoreo = this.actividadParaEditar.herramientasYcontroles
      }else
      if(this.actividadParaEditar.actividad == 'OTROS'){
        // this.otros=this.dataActividad
        this.otros=this.actividadParaEditar.dataActividad
        this.herramientasYControlesOtros = this.actividadParaEditar.herramientasYcontroles
      }

  }

  anadirTarea(){
      console.log(this.crearOeditar)
      this.metealarraydeactividades(()=>{
        this.updatefirebase(()=>{
          this.modalCtrl.dismiss();
          this.servicioLoadersAlertasService.presentToast("¡Tarea añadida! / Task added!")
        })
      })
  }


  editarTarea(){
    this.actualizaArray(()=>{
      this.updatefirebase(()=>{
        this.modalCtrl.dismiss()
        this.servicioLoadersAlertasService.presentToast("¡Tarea editada! / Task updated!")
      })
    })
  }

  actualizaArray(callback){
    if(this.actividadParaEditar.actividad =='TRABAJO EN ALTURAS'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.trabajoenalturas
      callback()
    }else
    if(this.actividadParaEditar.actividad =='TRABAJO EN CALIENTE'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.trabajoencaliente
      callback()
    }else
    if(this.actividadParaEditar.actividad =='LEVANTAMIENTO MECÁNICO'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.levantamientomecanico
      callback()
    }else
    if(this.actividadParaEditar.actividad =='ENERGÍAS PELIGROSAS'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.energiaspeligrosas
      callback()
    }
    if(this.actividadParaEditar.actividad =='ESPACIOS CONFINADOS'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.espaciosconfinados
      callback()
    }else
    if(this.actividadParaEditar.actividad =='ESPACIOS CONFINADOS'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.espaciosconfinados
      callback()
    }else
    if(this.actividadParaEditar.actividad =='HAZMAT'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.hazmat
      callback()
    }else
    if(this.actividadParaEditar.actividad =='TRABAJO EN CALIENTE'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.trabajoencaliente
      callback()
    }else
    if(this.actividadParaEditar.actividad =='SUPERVISIÓN Y MONITOREO'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.supervisionymonitoreo
      callback()
    }else
    if(this.actividadParaEditar.actividad =='OTROS'){
      // console.log("ARRAYDEEMPLEADOS[indicetrabajador].arraydeactividades[indiceActividadParaEditar] ---> "+ this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad)
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades[this.indiceActividadParaEditar].dataActividad = this.otros
      callback()
    }
  }



  metealarraydeactividades(callback){

    if(this.actividadSeleccionada == 'TRABAJO EN ALTURAS'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.trabajoenalturas})
      callback()
    }else
    if(this.actividadSeleccionada == 'TRABAJO EN CALIENTE'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.trabajoencaliente})
      callback()
    }else
    if(this.actividadSeleccionada == 'LEVANTAMIENTO MECÁNICO'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.levantamientomecanico})
      callback()
    }else
    if(this.actividadSeleccionada == 'ENERGÍAS PELIGROSAS'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.energiaspeligrosas})
      callback()
    }else
    if(this.actividadSeleccionada == 'ESPACIOS CONFINADOS'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.espaciosconfinados})
      callback()
    }else
    if(this.actividadSeleccionada == 'HAZMAT'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.hazmat})
      callback()
    }else
    if(this.actividadSeleccionada == 'TRABAJO EN CALIENTE'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.trabajoencaliente})
      callback()
    }else
    if(this.actividadSeleccionada == 'SUPERVISIÓN Y MONITOREO'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.supervisionymonitoreo})
      callback()
    }else
    if(this.actividadSeleccionada == 'OTROS'){
      this.arrayDeEmpleados[this.indicetrabajador].arraydeactividades.push({actividad:this.actividadSeleccionada, dataActividad:this.otros})
      callback()
    }
  }

  
  

  updatefirebase(callback){
    let referenciaalPTW = firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud)
    referenciaalPTW.update({
      arrayDeEmpleados:this.arrayDeEmpleados
    }).then(()=>{
      console.log("actualizado")
      callback()
    }).catch((err)=>{
      callback()
    })
  }

  

  cancelar(){
    this.modalCtrl.dismiss();
  }

  
  // moment(this.vencimientoCertAlturas).format('YYYY-MM-DD');




//OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
//OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
//OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.


  inputfile(event,nombreparametro) {
    this.servicioLoadersAlertasService.presentLoading("Cargando archivo... / Loading file...");

    this.subiendo = nombreparametro
    this.changedData=true
    this.percentage=0;
    // File or Blob named mountains.jpg
    var file = event.target.files[0]

    // Create the file metadata
    var metadata = {
      // contentType: 'image/jpeg'
    };
    // Upload file and metadata to the object 'images/mountains.jpg'
    let storageRef = firebase.storage().ref('parafiscales/' + Date.now())
    var uploadTask = storageRef.child('images/' + file.name).put(file, metadata);

    // Listen for state changes, errors, and completion of the upload.
    uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
      (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded

        this.percentage = (snapshot.bytesTransferred / snapshot.totalBytes)
        console.log('Upload is ' + this.percentage + '% done');
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused');
            break;
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running');
            break;
        }
      }, (error) => {
        console.log(error);
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        this.servicioLoadersAlertasService.loadingController.dismiss()
        this.servicioLoadersAlertasService.alerta("Error",error)
      }, () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log('File available at', downloadURL);

            if(nombreparametro == 'Cert. trabajo en alturas'){
              //CAMBIAMOS LA URL EN EL OBJETO
            this.trabajoenalturas.urlCertificado = downloadURL
            //ACTUALIZAMOS EL ARRAY
            this.actualizaArray(()=>{
              this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
               //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
              firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoAlturas:downloadURL}).then(()=>{
                this.servicioLoadersAlertasService.loadingController.dismiss()
              })
            })

          }
          if(nombreparametro == 'Cert. aptitud ocupacional'){
            this.trabajoenalturas.urlCertificadoMedico=downloadURL
            //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
            //ACTUALIZAMOS EL ARRAY
            this.actualizaArray(()=>{
              this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
               //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
              firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoAptitud:downloadURL}).then(()=>{
                this.servicioLoadersAlertasService.loadingController.dismiss()
              })
            })

          }
          if(nombreparametro == 'Cert. para izaje'){
            this.levantamientomecanico.urlCertificadoIzaje=downloadURL;
            //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
           //ACTUALIZAMOS EL ARRAY
           this.actualizaArray(()=>{
            this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
             //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoIzaje:downloadURL}).then(()=>{
              this.servicioLoadersAlertasService.loadingController.dismiss()
            })
          })
       
          }
          if(nombreparametro == 'Cert. conte'){
            this.energiaspeligrosas.urlCertCONTE=downloadURL
            //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
            //ACTUALIZAMOS EL ARRAY
           this.actualizaArray(()=>{
            this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
             //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoCONTE:downloadURL}).then(()=>{
              this.servicioLoadersAlertasService.loadingController.dismiss()
            })
          })
           
          }
          if(nombreparametro == 'Cert. confinados'){
            this.espaciosconfinados.urlCertificadoConfinados
           //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
             //ACTUALIZAMOS EL ARRAY
           this.actualizaArray(()=>{
            this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
             //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoConfinados:downloadURL}).then(()=>{
              this.servicioLoadersAlertasService.loadingController.dismiss()
            })
          })
           
          }
          if(nombreparametro == 'Cert. aptitud confinados'){
            this.espaciosconfinados.urlCertificadoAptitudConfinados=downloadURL
            //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
               //ACTUALIZAMOS EL ARRAY
           this.actualizaArray(()=>{
            this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
             //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoAptitudConfinados:downloadURL}).then(()=>{
              this.servicioLoadersAlertasService.loadingController.dismiss()
            })
          })
    
          }
          if(nombreparametro == 'Cert. equipos confinados'){
            this.espaciosconfinados.urlCertificadoEquiposConfinados=downloadURL
            //OJO!!! ACA TAMBIEN HAY QUE CAMBIAR LA URL DE LOS DOCUMENTOS EN EL TRABAJADOR.
            //ACTUALIZAMOS EL ARRAY
           this.actualizaArray(()=>{
            this.servicioLoadersAlertasService.presentToast("¡Documento actualizado! / Document updated!")
             //Y LUEGO ACTUALIZAMOS LA URL DEL NUEVO DOCUMENTO EN LA COLECCION DE TRABAJADORES
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoEquiposConfinados:downloadURL}).then(()=>{
              this.servicioLoadersAlertasService.loadingController.dismiss()
            })
          })
          }

          this.servicioLoadersAlertasService.loadingController.dismiss()

        }).catch((err)=>{
          this.servicioLoadersAlertasService.loadingController.dismiss()
        this.servicioLoadersAlertasService.alerta("Error",err)
        });
        
      });
  }

 

  async confirmdelete(url,nombredeldocumento) {
    const alert = await this.servicioLoadersAlertasService.alertController.create({
      header: '¿Eliminar documento? / Delete document?',
      message: '¿Seguro que desea <strong>eliminar este documento</strong>? Esta acción no tendrá reversa. / Sure you want to <strong>delete this document?</strong> this action can not be undone.',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
            console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'OK',
          handler: () => {
           this.deleteDocument(url,nombredeldocumento)
          }
        }
      ]
    });
    await alert.present();
  }

  deleteDocument(url,nombredeldocumento){
    // Create a reference to the file to delete
    var httpsReference = firebase.storage().refFromURL(url)
    // Delete the file
    httpsReference.delete().then(()=> {

    // File deleted successfully
      console.log("Deleted OK")
      console.log()
     
      this.percentage=0 
          if(nombredeldocumento == 'Cert. trabajo en alturas'){
            this.trabajoenalturas.urlCertificado='';
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoAlturas:''})
         }else
          if(nombredeldocumento == 'Cert. aptitud ocupacional'){
            this.trabajoenalturas.urlCertificadoMedico='' ;
            firebase.firestore().collection("trabajadores").doc(this.trabajador.id).update({urlCertificadoAptitud:''})
        }else
          if(nombredeldocumento == 'Cert. para izaje'){this.levantamientomecanico.urlCertificadoIzaje='' }else
          if(nombredeldocumento == 'Cert. conte'){this.energiaspeligrosas.urlCertCONTE='' }else
          if(nombredeldocumento == 'Cert. confinados'){this.espaciosconfinados.urlCertificadoConfinados='' }else
          if(nombredeldocumento == 'Cert. aptitud confinados'){this.espaciosconfinados.urlCertificadoAptitudConfinados='' }else
          if(nombredeldocumento == 'Cert. equipos confinados'){this.espaciosconfinados.urlCertificadoEquiposConfinados='' }
          
      }).catch((error)=> {
        // Uh-oh, an error occurred!
        this.servicioLoadersAlertasService.alerta("¡Error!",error)
      });
    }



}//fin de clase



